<template>
  <div class="PostItem-actions" v-if="this.$route.name !== 'content-library'">
    <div class="PostItem-buttons">
      <div class="font-secondary">{{ $t("posts.card.actionsOnThisAd") }}</div>
      <el-button-group v-if="etat !== 'V' && etat !== 'S'">
        <el-button v-if="typeObjet >= 3000 && typeObjet < 4000 && etat !== 'M'"
                   @click="gererLots(id)"
                   size="mini"
                   plain
        >
          <span @click="eventAnalytics('gerer_lots_prom')">{{ $t("posts.card.manageLots") }}</span>
        </el-button>
        <el-button
            :to="{ name: 'post-view', params: { post: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            v-if="saisit_en_ligne && ((typeObjet < 3000 || typeObjet >= 4000) || possedeContactManager === false) && (!isSubUser || (isSubUser && etat !== 'M'))"
            @click="goToEdit(id)"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.card.edit") }}</span>
        </el-button>
        <el-button
            v-if="hasSocialPostsAccess && (etat !== 'M' && etat !== 'B' && !isPromoteur && !isBailleurSocial)"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="hasSocialPostsAccess && (etat !== 'M' && etat !== 'B' && (isBailleurSocial && (typeObjet < 3000 || typeObjet >= 4000)))"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="hasSocialPostsAccess && (etat !== 'M' && etat !== 'B' && isPromoteur && annonceParente != null)"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="(etat !== 'M' && typeOffre !== 'L' && sitimmoUser.soldProductsOption === true && !isPromoteur && !isCmiste)"
            :to="{ name: 'edit-bien-vendu', params: { id: id } , query: {valueEtat: etat}}"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('bien-vendu')" v-if="etat === 'V'">{{ $t("posts.card.managePosts") }}</span>
          <span @click="eventAnalytics('bien-vendu')" v-else>{{$t('posts.list.bienVendu')}}</span>
        </el-button>

        <el-button :to="{name :'portals-selection-post', params: { post : id }}"
                   v-if="etat !== 'M' && etat !== 'B' && !sitimmoUser.soldProductsOption === true"
                   size="mini"
                   plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>
        <el-button size="mini" plain v-if="saisit_en_ligne && etat === 'M' && $route.name !== 'content-library'" @click="$emit('open-use-model-modal', { id: id })">{{ $t("posts.card.useThisModel") }}</el-button>
        <el-button size="mini" plain v-if="etat === 'M'" @click="$emit('open-delete-modal', { id: id, etat: etat })"> {{ $t("posts.card.delete") }}</el-button>

        <el-dropdown v-if="dropdownItems.length > 0" @command="handleCommand" placement="top">
          <el-button size="mini" icon="more-alt" type="info" icon-align="right" @click.prevent.native />
          <el-dropdown-menu slot="dropdown" :append-to-body="false" :style="{ width: '200px', transition: 'opacity 0.3s ease' }" :popper-options="{ preventOverflowOrder: [] }">
            <el-dropdown-item v-for="item in dropdownItems" :key="item.command.name" :command="item.command">
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-button-group>
      <el-button-group v-else-if="etat === 'V'">
        <el-button :to="{ name: 'post-view', params: { post: id } }" size="mini" plain>
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button :to="{ name: 'edit-bien-vendu', params: { id: id } }" size="mini" plain>
          <span @click="eventAnalytics('bien-vendu-edit')">{{ $t("posts.card.edit") }}</span>
        </el-button>
        <el-button
            v-if="hasSocialPostsAccess"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('bien-vendu-post')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button :to="{name :'portals-selection-post', params: { post : id }}" size="mini" plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>
        <el-button size="mini" plain>
          <span @click="$emit('archiver-bien-vendu-modale', { id: id, published: published })">Archiver</span>
        </el-button>
      </el-button-group>
      <el-button-group v-else-if="etat ==='S'">
        <el-button :to="{ name: 'post-view', params: { post: id } }" size="mini" plain>
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button :to="{ name: 'edit-bien-vendu', params: { id: id } }" size="mini" plain>
          <span @click="eventAnalytics('bien-vendu')" v-if="etat === 'V'">{{ $t("posts.card.managePosts")}}</span>
          <span @click="eventAnalytics('bien-vendu')" v-else>{{$t('posts.list.bienVendu')}}</span>
        </el-button>
      </el-button-group>
    </div>

    <div class="PostItem-contacts" v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur">
      <em class="el-icon-date" style="font-size: 2em;"></em>
      <div class="PostItem-contacts-label text-center">
        {{$t('posts.list.diffuseLater.diffusedAt')}} <br>
        {{donnees.date_debut_diffusion.valeur}}
      </div>
    </div>

    <div class="PostItem-contacts" v-if="(possedeContactManager === true || etat !== 'S') || etat !== 'V'">
      <el-tooltip :content="$t('contactManager.sevenDays')" placement="top">
        <router-link :to="{ name: 'contacts-posts-detail', params: { post: reference}, query: { from: $route.name }}" class="lienContactsListeAnnonces">
          <div class="PostItem-contacts-value text-center">
            {{nbContactsMailtracking && nbContactsMailtracking.nbContact ? nbContactsMailtracking.nbContact : 0}}
          </div>
          <div class="PostItem-contacts-label text-center">
            {{ $t("posts.card.contacts") }}
          </div>
        </router-link>
      </el-tooltip>
    </div>
  </div>

  <div class="PostItem-actions" v-else>
    <div class="PostItem-buttons">
      <div class="font-secondary">{{ $t("posts.card.actionsOnThisAd") }}</div>
      <el-button-group>
        <el-button v-if="typeObjet >= 3000 && typeObjet < 4000 && (isPromoteur || isBailleurSocial)" @click="setAnnonceParente(id)" size="mini" plain>
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.manageLots") }}</span>
        </el-button>
        <el-button :to="{ name: 'post-view', params: { post: id } }" size="mini" plain>
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            size="mini"
            plain
            v-if="etat === 'M' && canDeleteModel"
            @click="$emit('open-delete-modal', { id: id, etat: etat })"
        >
          {{ $t("posts.card.delete") }}
        </el-button>
        <el-button v-if="saisit_en_ligne && ((typeObjet < 3000 || typeObjet >= 4000) || possedeContactManager === false) && (!isSubUser || (isSubUser && etat !== 'M'))" :to="{ name: 'model-edit', params: { id: id }, query: { saisie: sourceCode } }" size="mini" plain>
          <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.card.edit") }}</span>
        </el-button>
        <el-button :to="{name :'portals-selection-post', params: { post : id }}" v-if="etat !== 'M' && etat !== 'B'" size="mini" plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>

        <el-dropdown v-if="dropdownItems.length > 0" @command="handleCommand" placement="top">
          <el-button size="mini" icon="more-alt" type="info" icon-align="right" @click.prevent.native />
          <el-dropdown-menu slot="dropdown" :append-to-body="false" :style="{ width: '245px', transition: 'opacity 0.3s ease' }" :popper-options="{ preventOverflowOrder: [] }">
            <el-dropdown-item v-for="item in dropdownItems" :key="item.command.name" :command="item.command">
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
    </div>

    <div class="PostItem-contacts" v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur">
      <em class="el-icon-date" style="font-size: 2em;"></em>
      <div class="PostItem-contacts-label text-center">
        {{$t('posts.list.diffuseLater.diffusedAt')}} <br>
        {{donnees.date_debut_diffusion.valeur}}
      </div>
    </div>

    <div class="PostItem-contacts" v-if="possedeContactManager === true">
      <el-tooltip :content="$t('contactManager.sevenDays')" placement="top">
        <router-link :to="{ name: 'contacts-posts-detail', params: { post: reference}, query: { from: 'post' }}" class="lienContactsListeAnnonces">
          <div class="PostItem-contacts-value text-center">
            {{nbContactsMailtracking && nbContactsMailtracking.nbContact ? nbContactsMailtracking.nbContact : 0}}
          </div>
          <div class="PostItem-contacts-label text-center">
            {{ $t("posts.card.contacts") }}
          </div>
        </router-link>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { getLotsUrl, getEditUrl, getAnnonceParenteFromRoute } from '@/helpers/programContext'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import { canDeleteModel as checkCanDeleteModel } from '@/helpers/posts/immoModelPermissions'

export default {
  name: 'CardFooter',
  props: ['id', 'etat', 'published', 'typeObjet', 'typeOffre', 'sourceCode', 'donnees', 'annonceParente', 'nbContactsMailtracking', 'reference'],
  computed: {
    ...mapState('posts', ['filter', 'results']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts', 'getUser']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    saisit_en_ligne () {
      return (getFromSnake(this.sitimmoUser, 'saisit_annonces_en_ligne') || (getFromSnake(this.sitimmoUser, 'saisit_en_ligne_et_flux')))
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    canDeleteModel () {
      return checkCanDeleteModel(this.isSubUser, this.getUser, this.donnees)
    },
    dropdownItems () {
      if (this.etat === 'M') return []

      const isLibrary = this.$route.name === 'content-library'

      return [
        {
          show: this.saisit_en_ligne,
          command: { name: 'duplicate', id: this.id },
          label: this.$t('posts.card.duplicate')
        },
        {
          show: isLibrary
            ? this.saisit_en_ligne && this.typeObjet >= 3000 && this.typeObjet < 4000 && this.possedeContactManager === true
            : this.saisit_en_ligne && this.typeObjet >= 3000 && this.typeObjet < 4000,
          command: { name: 'edit', id: this.id, sourceCode: this.sourceCode },
          label: this.$t('posts.card.edit')
        },
        {
          show: !this.donnees.date_debut_diffusion && this.etat !== 'A',
          command: { name: 'diffuseLater', id: this.id, diffuseLaterDate: this.donnees.date_debut_diffusion },
          label: this.$t('posts.list.diffuseLater.planDiffusion')
        },
        {
          show: this.donnees.date_debut_diffusion && this.donnees.date_debut_diffusion.valeur && this.etat !== 'A',
          command: { name: 'diffuseLater', id: this.id, diffuseLaterDate: this.donnees.date_debut_diffusion },
          label: this.$t('posts.list.diffuseLater.reportDiffusion')
        },
        {
          show: this.sitimmoUser.garantiePublication,
          command: { name: 'attendanceReport', id: this.id, analytics: 'rapport_presence' },
          label: this.$t('posts.card.presenceReport')
        },
        {
          show: this.saisit_en_ligne,
          command: { name: 'delete', id: this.id },
          label: this.$t('posts.card.delete')
        },
        {
          show: !isLibrary,
          command: { name: 'private-note', id: this.id, analytics: 'acces_note_privee' },
          label: this.$t('posts.card.privateNote')
        },
        {
          // Combine les deux conditions (Bailleur prog / Promo ou Bailleur) liées à "Manage Posts"
          show: this.hasSocialPostsAccess && !isLibrary && this.etat !== 'B' && (
            (this.filter.annonceParente == null && (this.isPromoteur || this.isBailleurSocial)) ||
              (this.annonceParente == null && this.isBailleurSocial && this.typeObjet >= 3000 && this.typeObjet < 4000)
          ),
          command: { name: 'manage-posts', id: this.id, analytics: 'gerer_posts' },
          label: this.$t('posts.card.managePosts')
        },
        {
          show: !isLibrary && this.etat === 'A' && this.sitimmoUser.soldProductsOption === true,
          command: { name: 'portals-selection', id: this.id, analytics: 'diffuser' },
          label: this.$t('posts.card.diffuse')
        }
      ].filter(item => item.show)
    },
    userRS () {
      return this.$store.getters.getUser.socialNetworkIds
    },
    hasSocialPostsAccess () {
      return this.userRS.length > 0 && this.sitimmoUser.packSocialManagement
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', [
      'SET_MODAL_DUPLICATE'
    ]),
    ...mapMutations('postsListImmo', [
      'resetFilter'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    goToEdit (id) {
      const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
      const editUrl = getEditUrl(id, currentAnnonceParente, this.sourceCode)
      this.$router.push(editUrl)
    },
    handleCommand (command) {
      if (!command) return

      // Centralisation du trigger d'analytics si l'item de menu en possède un
      if (command.analytics) {
        this.eventAnalytics(command.analytics)
      }

      if (command.name === 'delete') {
        this.$emit('open-delete-modal', { id: command.id, etat: this.etat })
      } else if (command.name === 'useModel') {
        this.$emit('open-use-model-modal', { id: command.id })
      } else if (command.name === 'duplicate') {
        this.$emit('open-duplicate-modal', { id: command.id })
      } else if (command.name === 'edit') {
        const currentAnnonceParente = getAnnonceParenteFromRoute(this.$route)
        const editUrl = getEditUrl(command.id, currentAnnonceParente, command.sourceCode)
        this.$router.push(editUrl)
      } else if (command.name === 'attendanceReport') {
        this.$router.push({ name: 'attendance-report-post', params: { post: command.id } })
      } else if (command.name === 'diffuseLater') {
        this.$emit('diffuse-later', { id: command.id, diffuseLaterDate: command.diffuseLaterDate })
      } else if (command.name === 'private-note') {
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'manage-posts') {
        this.$router.push({ name: 'manage-posts', params: { id: command.id } })
      } else if (command.name === 'portals-selection') {
        this.$router.push({ name: 'portals-selection-post', params: { post: command.id } })
      }
    },
    gererLots (id) {
      const lotsUrl = getLotsUrl(id)
      this.$router.push(lotsUrl)
    }
  }
}
</script>

<style scoped>
.el-button-group {
  display: inline!important;
}
.PostItem-actions .PostItem-buttons {
  min-width: max-content;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
</style>
